import { render, staticRenderFns } from "./EditDataRecibo.vue?vue&type=template&id=b9ccc3a4"
import script from "./EditDataRecibo.vue?vue&type=script&lang=js"
export * from "./EditDataRecibo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports